export default "__VITE_ASSET__7ev22f_F__"